import { Config } from "./configTypes";

const malaysiaConfig: Config = {
  siteTitle: "Trive Malaysia",
  whatsappUrl: "+601116348323",
  company: {
    COMPANY_ID: Number(process.env.REACT_APP_COMPANY_ID) || 0,
    SUPPORT_EMAIL: process.env.REACT_APP_SUPPORT_EMAIL || "",
  },
  api: {
    API_URL: process.env.REACT_APP_API_URL || "",
    DEPOSIT_URL: process.env.REACT_APP_DEPOSIT_URL || "",
    FAQ_URL: process.env.REACT_APP_FAQ_REDIRECT_URL || "",
  },
};

export default malaysiaConfig;
